<template>
  <div class="mt-6 flex items-center justify-center">
    <div v-if="loading" class="text-center text-gray-500">
      Loading proof of payment...
    </div>
    <img
      v-else
      :src="proofImageUrl"
      alt="Proof of Payment"
      class="w-5/12 h-5/12 object-cover border"
    />
  </div>
</template>

<script>
import { inject, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import CryptoJS from "crypto-js";

export default {
  setup() {
    const axios = inject("$axios");
    const route = useRoute();
    const fileData = ref(null);
    const proofImageUrl = ref();
    const loading = ref(true); // ✅ Loading state

    onMounted(() => {
      fileData.value = route.params.id;
      console.log("render", fileData.value);

      const bytes = CryptoJS.AES.decrypt(
        fileData.value,
        process.env.VUE_APP_ENCRYPT_SECRET_KEY
      );
      const fileSaltModified = bytes.toString(CryptoJS.enc.Utf8);
      console.log("bcrypt", fileSaltModified);
      fileData.value = fileSaltModified;

      handlerAttachFile(fileData.value);
    });

    const handlerAttachFile = async (val) => {
      loading.value = true; // Start loading
      try {
        const response = await axios.get(
          `/portal/application/reimbursement/payment/attachment`,
          {
            params: { filename: val },
            responseType: "blob",
          }
        );
        proofImageUrl.value = URL.createObjectURL(response.data);
      } catch (error) {
        console.error("Failed to fetch profile image:", error);
      } finally {
        loading.value = false; // Stop loading regardless of success/failure
      }
    };

    return {
      fileData,
      handlerAttachFile,
      proofImageUrl,
      loading, // ✅ return loading
    };
  },
};
</script>
